module.exports = __webpack_public_path__ + "img/88ne.1e34ba6b.svg";